import {
  GETUSER,
  GETUSERDETAIL,
  GET_DEPARTMENT_WISE_USER,
  GET_USER_DATA_REQUEST,
  GET_USER_DETAILS_BY_EMAIL,
  GET_USER_DATA_BY_EMAIL_COMPANY,
  GET_COMPANY_NAMES,
  GET_USER_DEPARTMENTS,
  GET_COLLABORATOR_BY_TYPE,
  GET_USERS_BY_DEPARTMENTID,
  GET_COLLABORATOR_BY_COMPANY,
  GET_ALL_USER_TYPES_INFO,
} from "../constants";
import { ApiCall } from "../../utils/index";
import axios from "axios";

export const getUser =
  (request, debouncedHandleSearch, page, row_count, sortField, sortOrder, departments) =>
  async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      let url = "/user/dashboard";
      if(page) {
        const searchParam = debouncedHandleSearch ? `search=${debouncedHandleSearch}&` : "";
        const params = `?${searchParam}page=${page}&page_size=${row_count}&sort_by=${sortField}&sort_order=${sortOrder}`;
        url = url + params
      }
      if(Array.isArray(departments) && departments?.length > 0){
        const department_id = departments.map(item => item.value)
        url = url + `&department_id=${JSON.stringify(department_id)}`;
      }
      const result = await ApiCall.get(url, token);
      dispatch({ type: GETUSER, payload: result.data });
      request?.onSuccess(result?.data?.data);
    } catch (error) {
      request?.onError();
    }
  };

export const createUser = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.post("/user", request.payload, token);
    request.onSuccess();
  } catch (error) {
    request.onError(error);
  }
};

export const createMultipleUser = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.post(
      "/user/createmultiple",
      request.payload,
      token
    );
    request.onSuccess();
  } catch (error) {
    request.onError(error);
  }
};

export const getUserById = (id) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    const result = await ApiCall.get(`/user/by_user_id/${id}`, token);

    dispatch({ type: GETUSERDETAIL, payload: result.data });
  } catch (error) {}
};

export const updateUser = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    const result = await ApiCall.patch(
      `/user/${request.user_id}`,
      request.payload,
      token
    );

    request.onSuccess();
  } catch (error) {
    request.onError(error);
  }
};

export const deleteUser = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    const result = await axios.delete(
      `${process.env.REACT_APP_API_URL}/user/${request.id}`,
      request.payload,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    request.onSuccess();
  } catch (error) {
    request.onError(error);
  }
};

export const userResetPassword =
  (payload, cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();

      const result = await ApiCall.post(
        "/passwordReset/reset_password_mail",
        payload,
        token
      );

      cb(result);
    } catch (error) {
      cb(error);
    }
  };

export const userResendPassword =
  (payload, cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();

      const result = await ApiCall.post(
        "/user/resend/verification_mail",
        payload,
        token
      );

      cb(result);
    } catch (error) {
      cb(error);
    }
  };

export const getUserListDepartmentWise =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(
        `/user/department_wise/user_list`,
        token
      );

      dispatch({
        type: GET_DEPARTMENT_WISE_USER,
        payload: result.data,
      });

      if(request.onSuccess) {
        request.onSuccess(result.data)
      }

    } catch (error) {
      request.onError();
    }
  };

// This API used in request page
export const getUserData = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.get(`/user/company`, token);

    dispatch({ type: GET_USER_DATA_REQUEST, payload: result.data });
  } catch (error) {
    request.onError();
  }
};

// This API used in activity performance embedded page
export const getUserDataByEmailAndCompanyId =
  () => async (dispatch, getState) => {
    try {
      const {
        auth: { company, email },
      } = getState();
      const result = await ApiCall.get(
        `/company/getuserdetails/${company.id}/${email}`
      );

      dispatch({ type: GET_USER_DATA_BY_EMAIL_COMPANY, payload: result.data });
    } catch (error) {}
  };

export const getUserDataByEmail = () => async (dispatch, getState) => {
  try {
    const {
      auth: { email },
    } = getState();
    const result = await ApiCall.get(`/user/email/${email}`);

    const data = result.data;
    const payload = {
      company_name: data.company.name,
      team_name: data.department_id.name,
      name: data.name,
    };

    dispatch({ type: GET_USER_DETAILS_BY_EMAIL, payload: payload });
  } catch (error) {}
};

export const customerPortal = (payload, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    const result = await axios.post(
      `${process.env.REACT_APP_API_URL}/stripe/customer-portal`,
      payload,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    cb(result.data);
  } catch (error) {
    cb(error.response.data);
  }
};

export const getUserDepartments = (id) => async (dispatch, getState) => {
  try {
    const result = await ApiCall.get(`/user/department_list/${id}`);

    dispatch({ type: GET_USER_DEPARTMENTS, payload: result.data });
  } catch (error) {
    console.log(error);
  }
};

export const getCollaboratorByType = (type) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.get(`/collaborator/by/${type}`, token);

    dispatch({ type: GET_COLLABORATOR_BY_TYPE, payload: result.data });
  } catch (error) {
    console.log(error);
  }
};

export const getCollaboratorByCompany =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(`/collaborator/byCompany`, token);

      dispatch({
        type: GET_COLLABORATOR_BY_COMPANY,
        payload: result.data,
      });
      if(request.onSuccess) {
        request.onSuccess(result.data)
      }
    } catch (error) {
      request.onError();
    }
  };
export const getAllUserTypesInfo = (cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.get(`/user/summary/users`, token);
    dispatch({ type: GET_ALL_USER_TYPES_INFO, payload: result.data });
    cb(result);
  } catch (error) {
    cb(error);
  }
};
